import * as types from "../ActionTypes/internalBanners";

export function fetchActiveInternalBannerResolved(payload) {
  return {
    type: types.FETCH_ACTIVE_INTERNAL_BANNER_RESOLVED,
    payload
  };
}